import IconKills from "./IconKills";

export default IconKills;